import { useRef } from "react";
import { useDropzone } from "react-dropzone";
import { Typography, Box } from "@mui/material";
import {
  Button,
  DialogActions,
  DialogContent,
  Grid,
} from "../../../../../../components";

const SelecionarArquivoCsvStep = ({
  arquivoCsv,
  setArquivoCsv,
  setActiveStep,
  setOpenImportarCSVDialog,
  buscarCsvData,
}) => {
  const csvUpload = useRef(null);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: [
      "text/csv",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ],
    onDrop: (acceptedFiles) => {
      handleCsvChange(acceptedFiles);
    },
  });

  function handleCsvChange(event) {
    if (event.target) {
      setArquivoCsv(event.target.files[0]);
    } else {
      setArquivoCsv(event[0]);
    }
  }

  return (
    <>
      <DialogContent sx={{ width: "100%" }}>
        <Grid
          container
          spacing={2}
          className="d-flex justify-content-center m-0 w-100"
        >
          <Box
            {...getRootProps()}
            sx={{
              width: "100%",
              height: "10rem",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "2rem",
              border:
                isDragActive || arquivoCsv
                  ? "2px dashed grey"
                  : "2px solid transparent",
              borderRadius: 2,
              padding: 2,
              backgroundColor:
                isDragActive || arquivoCsv ? "#e3f2fd" : "#fafafa",
              ":hover": {
                backgroundColor: "#e3f2fd",
                border: "2px dashed grey",
              },
            }}
            onClick={() => csvUpload.current.click()}
          >
            <input
              {...getInputProps()}
              type="file"
              style={{ display: "none" }}
              ref={csvUpload}
              onChange={(event) => handleCsvChange(event.target.files)}
            />
            <h4 className="m-0 text-center" style={{ fontWeight: 800 }}>
              {arquivoCsv
                ? "Arquivo Selecionado!"
                : "Arraste e solte ou Clique aqui para importar arquivo CSV"}
            </h4>
            {arquivoCsv?.name && (
              <div className="mt-2">
                <Typography>{arquivoCsv.name}</Typography>
              </div>
            )}
          </Box>
        </Grid>
      </DialogContent>
      <DialogActions className="w-100 d-flex justify-content-end">
        <Button
          variant="contained"
          onClick={() => {
            setArquivoCsv(null);
            setActiveStep(0);
            setOpenImportarCSVDialog(false);
          }}
        >
          Fechar
        </Button>
        {arquivoCsv && (
          <Button
            variant="contained"
            onClick={() => {
              if (arquivoCsv) {
                setActiveStep(1);
                buscarCsvData();
              }
            }}
          >
            Próximo
          </Button>
        )}
      </DialogActions>
    </>
  );
};

export default SelecionarArquivoCsvStep;
